import axios from "axios"

export default {
    getUserFriend(params){
        return axios.post('/api/v1/im/h5jmessage/getUserFriend',params)
    },
    queryHistoryMessage(params){
        return axios.post('/api/v1/im/h5jmessage/queryHistoryMessage',params)

    },
    changeReadStatus(params){
        return axios.post('/api/v1/im/h5jmessage/changeReadStatus',params)

    },
    getCustomerList(params){
        return axios.post('/api/v1/im/h5jmessage/getCustomerList',params)

    },
    getConsultOrderList(params){
        return axios.post('/api/v1/im/h5jmessage/getConsultOrderList',params)

    },
    getCustomerListScreen(params){
        return axios.post('/api/v1/im/h5jmessage/getCustomerListScreen',params)

    },
    getUnreadMsg(params){
        return axios.post('/api/v1/im/h5jmessage/getUnreadMsg',params)

    },
    
    
}